import { debounce, DebounceSettings, DebouncedFunc } from "lodash";

const DEFAULT_DELAY = 500;
const DEFAULT_OPTIONS: DebounceSettings = {
  leading: true,
  trailing: false,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounceFn<T extends (...args: any[]) => any>(
  fn: T,
  delay: number = DEFAULT_DELAY,
  options?: DebounceSettings,
): DebouncedFunc<T> {
  return debounce(fn, delay, { ...DEFAULT_OPTIONS, ...options });
}
